
	import Vue from 'vue';
	import Component from 'vue-class-component';

	import StringFormatter, { StringMetadata } from '@/services/Formatter/StringFormatter';

	const Props = Vue.extend({
		props: {
			value: {
				type: String,
				required: true
			},
			splitLength: {
				type: Number,
				required: true
			},
			splitTimes: {
				type: Number,
				required: true
			}
		}
	});

	@Component
	export default class TextTooltipFormatter extends Props {
		get stringMetadata() {
			return StringFormatter.splitAndOrTruncate(this.value, this.splitLength, this.splitTimes) as StringMetadata;
		}
	}
